export default __webpack_public_path__ + "static/media/todolist.13d4bc14.png";